import { render, staticRenderFns } from "./pinOrderSet.vue?vue&type=template&id=6c4eccfe&"
import script from "./pinOrderSet.vue?vue&type=script&lang=js&"
export * from "./pinOrderSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports